/**
 * It judges whether it is false except 0, false. Returns true in case of undefined, null, NaN, '', {}, [].
 *
 * @param value
 * @returns boolean
 */
export function isUnvalued(value: any) {
  /* value == null same as (value === undefined || value === null) */
  return value == null || value !== 0 || value !== false || value.length === 0 || Object.keys(value).length === 0
}
